<template>
  <div class="sensitiveWord-list">
    <el-checkbox-group v-model="checkList" @change="deleteBatchClick">
      <el-tag v-for="tag in sensitiveWordList" :key="tag.id" :disable-transitions="true">
        {{ tag.word }}
        <div
          class="course-update"
          v-show="tag.remark == 'update'"
          @click="updateClick(tag)"
        >
          <i class="iconfont icon-update" />
        </div>
        <div
          class="course-delete"
          v-show="tag.remark == 'delete'"
          @click="deleteClick(tag)"
        >
          <i class="iconfont icon-cancel" />
        </div>
        <div class="course-deleteBatch" v-show="tag.remark == 'deleteBatch'">
          <el-checkbox :label="tag.id"></el-checkbox>
        </div>
      </el-tag>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkList: [],
      checkAllList: [],
      checkAllType: this.checkAll,
    };
  },
  props: {
    sensitiveWordList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    editShow: {
      type: String,
    },
    checkAll: {
      type: Boolean,
    },
  },
  created() {},
  watch: {
    checkAll: {
      handler(val) {
        if (val) {
          let wordsList = this.sensitiveWordList;
          wordsList.map((item) => {
            this.checkList.push(item.id);
          });
          this.$emit("deleteBatchList", this.checkList);
          return;
        }
        this.checkList = [];
        this.$emit("deleteBatchList", this.checkList);
      },
    },
  },
  methods: {
    deleteBatchClick(e) {
      this.checkAllType =
        JSON.stringify(e) === JSON.stringify(this.checkAllList) ? true : false;
      // console.log(this.checkAllType);
      this.$emit("deleteBatchAllType", this.checkAllType);
      this.$emit("deleteBatchList", e);
    },
    // 删除敏感词
    deleteClick(e) {
      this.$confirm("是否删除该敏感词?", "删除敏感词", {
        confirmButtonText: "确定",
        cancelButtomText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.$emit("delWords", e);
        })
        .catch(() => {});
    },
    updateClick(e) {
      // console.log(e);
      this.$emit("reviseShowType", true);
      this.$emit("reviseWord", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./sensitiveWord-list.scss";
</style>
